// CFT maths for the screens — same as the server (services/cftMath.js) and the CFT sheets:
// CFT per piece = L × W × T (mm) × 0.00000003528 ; total = per piece × qty, 4 decimals
export const CFT_CONSTANT = 0.00000003528;
export const r4 = n => Math.round((Number(n) || 0) * 10000) / 10000;
export const fmt4 = n => Number(n || 0).toFixed(4);
export function rowCft(row) {
  const g = (Number(row.length) || 0) * (Number(row.width) || 0) * (Number(row.thickness) || 0) * CFT_CONSTANT;
  return { gross: r4(g), net: r4(g * (Number(row.qty) || 0)) };
}

// ── Thickness categories: every wood has its thicknesses (25, 38 mm …) plus "ALL CFT",
// a separate category whose CFT is typed directly (board sizes unknown).
export const isAllRow = r => r?.is_all_cft === true || Number(r?.is_all_cft) === 1;
export const mm = v => Math.round((Number(v) || 0) * 1000) / 1000;
export const tKey = (isAll, t) => (isAll ? 'ALL' : String(mm(t)));
export const keyLabel = k => (k === 'ALL' ? 'ALL CFT' : `${mm(k)} mm`);
// CFT of a row: ALL CFT rows carry the typed CFT in net_cft
export const anyCft = r => (isAllRow(r) ? { gross: 0, net: r4(Math.max(0, Number(r.net_cft) || 0)) } : rowCft(r));
// Thicknesses offered for a wood: active ones, plus any value a row already uses
export const thicknessOptions = (wood, keep = []) => {
  const list = (wood?.thicknesses || []).filter(t => t.is_active || keep.map(mm).includes(mm(t.thickness))).map(t => mm(t.thickness));
  return [...new Set(list)].sort((a, b) => a - b);
};

// "Plank 2400×150×50"  ·  "ALL CFT"
export const sizeText = r => (isAllRow(r)
  ? `${r.label ? `${r.label} · ` : ''}ALL CFT`
  : `${r.label ? `${r.label} ` : ''}${Number(r.length) || 0}×${Number(r.width) || 0}×${Number(r.thickness) || 0}`);
